/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Modal from "react-modal";
import { theme } from "styles/theme";
import Button from "uis/Button";

type Props = {
    modalIsOpen: boolean;
    closeModal: () => void;
    email?: string;
    onHandleConfirm?: () => void;
};

Modal.setAppElement("#root");

const modalStyle = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        padding: "40px 80px",
        transform: "translate(-50%, -50%)",

        borderRadius: "15px",
    },
    overlay: {
        backgroundColor: "var(--component-color-material-dimmer)",
        zIndex: 1,
    },
};

const Title = styled.p`
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    line-height: 120%;
`;

const BtnGroup = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
`;

const ReceiveEmailModal = (props: Props) => {
    const { email, modalIsOpen, closeModal, onHandleConfirm } = props;
    return (
        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 40px;
                `}
            >
                <Title>{email}로<br/>바로 이용 방법을 안내받아보세요!</Title>

                <BtnGroup>
                    <Button
                        onClick={closeModal}
                        title="취소하기"
                        type="secondary"
                        styles={{
                            container: css`
                                width: 150px;
                                height: 56px;
                                background-color: ${theme.neutral100};
                                &:hover {
                                    background-color: ${theme.neutral200};
                                }
                            `,
                            text: css`
                                font-size: 16px;
                                color: ${theme.neutral900};
                            `,
                        }}
                    />
                    <Button
                        onClick={onHandleConfirm}
                        title="즉시 안내받기"
                        styles={{
                            container: css`
                                width: 190px;
                                height: 56px;
                            `,
                            text: css`
                                font-size: 16px;
                            `
                        }}
                    />
                </BtnGroup>
            </div>
        </Modal>
    );
};

export default ReceiveEmailModal;
